import { Link } from "react-router-dom";
import { Newspaper, CalendarDays, ArrowRight, ArrowLeft } from "lucide-react";
import { BLOG_POSTS } from "@/lib/data";

function formatDate(iso) {
  try {
    return new Date(iso).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" });
  } catch {
    return iso;
  }
}

export default function Blog() {
  return (
    <div data-testid="blog-page">
      {/* Header */}
      <section className="max-w-6xl mx-auto px-6 lg:px-10 py-20 md:py-28">
        <p className="inline-flex items-center gap-2 text-xs tracking-[0.25em] uppercase text-[#8B7E74] mb-6 fade-up">
          <Newspaper size={14} /> Le blog
        </p>
        <h1 data-testid="blog-title" className="font-serif text-5xl md:text-6xl lg:text-7xl text-[#4A403A] leading-[1.05] max-w-4xl fade-up fade-up-delay-1">
          Conseils & ressources<br/>
          <em className="text-[#BA8E82]">pour le quotidien</em>.
        </h1>
        <p className="mt-8 text-lg text-[#8B7E74] leading-relaxed max-w-2xl fade-up fade-up-delay-2">
          Des articles pour accompagner les parents jour après jour : émotions, sommeil, jeu,
          aménagement de l'espace… De nouveaux contenus arrivent régulièrement.
        </p>
      </section>

      {/* Posts */}
      <section className="max-w-7xl mx-auto px-6 lg:px-10 pb-24">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {BLOG_POSTS.map((post) => (
            <Link
              key={post.slug}
              to={`/blog/${post.slug}`}
              data-testid={`blog-post-${post.slug}`}
              className="group bg-white rounded-3xl p-8 border border-[#E5DCD6] shadow-softer flex flex-col transition-all duration-300 hover:-translate-y-1 hover:shadow-soft"
            >
              <div className="flex items-center gap-3 mb-5">
                <span className="text-xs tracking-[0.18em] uppercase text-[#BA8E82] bg-[#F4EBE6] rounded-full px-3 py-1">{post.tag}</span>
                <span className="inline-flex items-center gap-1 text-xs text-[#8B7E74]">
                  <CalendarDays size={12} /> {formatDate(post.date)}
                </span>
              </div>
              <h2 className="font-serif text-2xl text-[#4A403A] mb-3 leading-tight">{post.title}</h2>
              <p className="text-[#8B7E74] leading-relaxed text-[15px] mb-6">{post.excerpt}</p>
              <span className="mt-auto text-sm text-[#4A403A] inline-flex items-center gap-2 link-underline self-start">
                Lire l'article <ArrowRight size={14} className="transition-transform group-hover:translate-x-1" />
              </span>
            </Link>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="max-w-5xl mx-auto px-6 lg:px-10 pb-32">
        <div className="bg-[#4A403A] rounded-[2rem] px-10 md:px-16 py-16 md:py-20 text-center">
          <h3 className="font-serif text-3xl md:text-4xl text-[#FAF7F2] mb-5">
            Une question sur votre situation&nbsp;?
          </h3>
          <p className="text-[#FAF7F2]/80 mb-9 max-w-xl mx-auto">
            Les articles ne remplacent pas un accompagnement sur mesure. Le 1<sup>er</sup> appel est gratuit.
          </p>
          <Link
            to="/rendez-vous"
            data-testid="blog-cta-booking"
            className="inline-flex items-center gap-2 rounded-full px-8 py-3.5 bg-[#D2A69A] text-[#4A403A] text-sm tracking-wide transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#FAF7F2]"
          >
            Prendre rendez-vous <ArrowRight size={15} />
          </Link>
        </div>
      </section>
    </div>
  );
}
